<template>
    <vs-table v-if="show" :params="params" :options="options"></vs-table>
</template>

<script>
import VsTable from "../_framework/VsTable.vue";
import VsSelect from "../_framework/VsSelect";

export default {
  name: "post",
  created: () => {},
  components: {
    VsTable
  },
  data() {
    return {
      show: true,
      access: {},
      params: {
        entity: "post",
        list: [],
        headers: {
          postName: {
            title: "عنوان سمت",
            type: "text"
          },
          postCode: {
            title: "کد سمت",
            type: "number"
          },
          access: {
            title: "دسترسی",
            type: "custom",
            component: VsSelect,
            multiple: false,
            label: "name",
            inHeader: true,
            isSearchable: false,
            listParams: {
              requestURI: "Access/GetAsDropdown"
            }
          }
        }
      },
      options: {
        hasActions: true,
        hasActionsInHeader: true,
        clickableRows: true,
        beforeCreateEntity: input => {
          // console.log(input);
          input["accessId"] = input.access.id;
          return input;
        }
        // onCreateHeaderActionClicked: true,
        // onEditClicked: (row, context) => {
        //   this.openUserAccess("edit");
        //   // new BaseService("orders").getById(row.id).then(rs => {
        //   //   this.openOrderDetail("edit", rs.data);
        //   // });
        // },
        // onRowDoubleClicked: row => {
        //   console.log(row);
        //   this.openUserAccess("view");
        //   // new BaseService("orders").getById(row.id).then(rs => {
        //   //   this.openOrderDetail("view", rs.data);
        //   // });
        // }
      }
    };
  },
  methods: {},
  beforeMount() {
    this.options.access = checkAccess(this.$route.path);
    //console.log(this.options.access);
    this.show = this.options.access ? true : false;
  }
};
</script>
